import React from 'react';
import SearchableSelect from '../SearchableSelect';

const MultiSelect = ({ options = [], value = [], onChange, placeholder = 'Add…', disabled, inputId }) => {
  const normalized = options.map((o) => (typeof o === 'string' ? { value: o, label: o } : o));
  const selected = Array.isArray(value) ? value : [];
  const available = normalized.filter((o) => !selected.includes(o.value));
  const labelFor = (v) => normalized.find((o) => o.value === v)?.label || v;

  const add = (v) => v && !selected.includes(v) && onChange([...selected, v]);
  const remove = (v) => onChange(selected.filter((item) => item !== v));

  return (
    <div>
      {selected.length > 0 && (
        <div className='flex flex-wrap gap-1 mb-1.5'>
          {selected.map((v) => (
            <span
              key={v}
              className='inline-flex items-center gap-1 text-xs px-2 py-0.5 rounded bg-blue-50 text-blue-700'
            >
              {labelFor(v)}
              {!disabled && (
                <button
                  type='button'
                  className='text-blue-400 hover:text-blue-700'
                  onClick={() => remove(v)}
                  aria-label={`Remove ${labelFor(v)}`}
                >
                  ×
                </button>
              )}
            </span>
          ))}
        </div>
      )}

      {!disabled && (
        <SearchableSelect
          inputId={inputId}
          options={available}
          value=''
          onChange={add}
          placeholder={selected.length ? 'Add one more…' : placeholder}
        />
      )}
    </div>
  );
};

export default MultiSelect;
